import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetPageService } from '../asset-page.service';
import { AssetForPortalFullAssetPage } from '../../shared/interfaces/research-portal/full-asset-page/asset-for-portal-full-asset-page.interface';
import { Location, AsyncPipe } from '@angular/common';
import { SEOService } from '../../core/seo.service';
import { ConfigurationHandlerService } from '../../core/configuration-handler.service';
import { take } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { ArcviewContainerComponent } from '../../parts/arcview/arcview-container/arcview-container.component';

@Component({
    selector: 'esp-asset-page-arcview-standalone',
    templateUrl: './asset-page-arcview-standalone.component.html',
    styleUrls: ['./asset-page-arcview-standalone.component.scss'],
    imports: [ArcviewContainerComponent, AsyncPipe, TranslateModule],
})
export class AssetPageArcviewStandaloneComponent {
    private assetPageService = inject(AssetPageService);
    route = inject(ActivatedRoute);
    private router = inject(Router);
    private location = inject(Location);
    private seoService = inject(SEOService);
    private configurationHandlerService = inject(ConfigurationHandlerService);

    assetTitle = '';
    assetDetails;
    _filesAndLinks = [];

    constructor() {
        const route = this.route;

        const mmsId = route?.snapshot?.params['mmsId'];
        this.assetPageService.getFullAssetPageByMmsId(mmsId).subscribe(
            (asset: AssetForPortalFullAssetPage) => {
                this.assetTitle =
                    asset.esploroAssetForPortalFullAssetPage.title;
                this.setPageTitle();
            },
            (error) => console.error(error),
        );
        this.assetPageService
            .getViewer(mmsId)
            .pipe(take(1))
            .subscribe((res: any) => {
                this._filesAndLinks = res?.files;
                this.assetDetails = this.parseMetadata(res?.metadata);
                this.setPageTitle();
            });
    }

    parseMetadata(mdObjects: { label; value }[]) {
        const mdResponse = [];
        let i = 0;
        for (const obj of mdObjects) {
            if (mdResponse[i] && mdResponse[i].label !== obj.label) {
                i++;
            }
            if (!mdResponse[i]) {
                mdResponse.push({ label: obj.label });
            }
            mdResponse[i].value = [...(mdResponse[i]?.value || []), obj.value];
        }
        return mdResponse;
    }

    handleArcviewIdxChange(index) {
        const urlTree = this.router
            .createUrlTree(['.'], {
                relativeTo: this.route,
                queryParamsHandling: 'merge',
                queryParams: { index },
            })
            .toString();
        this.location.replaceState(urlTree);
        this.setPageTitle();
    }

    setPageTitle() {
        const instName = this.configurationHandlerService.mainInstitutionName();
        const currentIdx = Number.parseInt(
            this.route.snapshot.queryParams['index'] || 0,
        );
        const fileName = this._filesAndLinks?.[currentIdx]?.label;
        this.seoService.updateTitle(
            `${this.assetTitle} - ${fileName} - ${instName}`,
        );
    }
}
